const address = 'mdi-map-marker-outline';
const box = 'mdi-inbox-multiple';
const cellPhone = 'mdi-cellphone';
const check = 'mdi-check-bold';
const checkCircle = 'mdi-checkbox-marked-circle';
const close = 'mdi-close';
const copy = 'mdi-content-copy';
const databaseSearch = 'mdi-database-search';
const dataRegisters = 'mdi-clipboard-text-outline';
const destroy = 'mdi-delete';
const domain = 'mdi-domain';
const dotsVertical = 'mdi-dots-vertical';
const download = 'mdi-download-box-outline';
const edit = 'mdi-pencil';
const email = 'mdi-email-outline';
const lockOutline = 'mdi-lock-outline'; 
const money = 'mdi-currency-usd'; 
const note = 'mdi-file-send-outline'; 
const noteMultiple = 'mdi-note-multiple'; 
const numeric = 'mdi-numeric';
const phone = 'mdi-phone';
const plus = 'mdi-plus';
const printer = 'mdi-printer';
const printerPos = 'mdi-printer-pos';
const refresh = 'mdi-refresh'; 
const save = 'mdi-content-save';
const security = 'mdi-shield-lock';
const origin = 'mdi-share-all';
const users = 'mdi-account-settings';
const view = 'mdi-eye';
const web = 'mdi-web';

export {
  address,
  box,
  databaseSearch,
  dataRegisters,
  destroy,
  domain,
  dotsVertical,
  download,
  cellPhone,
  check,
  checkCircle,
  close,
  copy,
  edit,
  email,
  phone,
  plus,
  printerPos,
  money,
  note,
  noteMultiple,
  numeric,
  lockOutline,
  printer,
  refresh,
  save,
  security,
  origin,
  users,
  view,
  web,
};